<app-item-image [src]="src" [size]="size" (loaded)="handleImageLoaded($event)"> </app-item-image>
